import PermissionTree from './PermissionTree';

export default PermissionTree;
